import { render, staticRenderFns } from "./LinkGroupsModal.vue?vue&type=template&id=c83280ac"
import script from "./LinkGroupsModal.vue?vue&type=script&lang=js"
export * from "./LinkGroupsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports